import React, { type KeyboardEvent, type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import { IconButton } from '@atlaskit/button/new';
import CloseIcon from '@atlaskit/icon/core/migration/close--cross';
import Tooltip from '@atlaskit/tooltip';
import { defineMessages } from '@atlassian/jira-intl';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';

// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

const messages = defineMessages({
	label: {
		id: 'issue.label-for-modal-close-button',
		defaultMessage: 'Close',
		description: '',
	},
});

type Props = {
	onClose: (
		e: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>,
		analyticsEvent: UIAnalyticsEvent,
	) => void;
};

export const ModalActionsCloseButton = ({ onClose }: Props) => {
	const intlCloseText = useIntl().formatMessage(messages.label);

	return (
		<div>
			<Tooltip content={intlCloseText} position="top">
				<UFOSegment name="issue-close-button">
					{isVisualRefreshEnabled() ? (
						<IconButton
							label={intlCloseText}
							appearance="default"
							spacing="default"
							icon={() => (
								<CloseIcon color="currentColor" spacing="spacious" label="" LEGACY_size="medium" />
							)}
							onClick={onClose}
							interactionName="auto-generated.jira-issue-view-foundation.button"
							testId="issue-view-foundation.modal-close-button"
						/>
					) : (
						<Button
							aria-label={intlCloseText}
							appearance="subtle"
							spacing="default"
							iconBefore={
								<CloseIcon color="currentColor" spacing="spacious" label="" LEGACY_size="medium" />
							}
							onClick={onClose}
							interactionName="auto-generated.jira-issue-view-foundation.button"
							testId="issue-view-foundation.modal-close-button"
						/>
					)}
				</UFOSegment>
			</Tooltip>
		</div>
	);
};

export default ModalActionsCloseButton;
